import { useEffect } from "react";
import { styles } from "./styles";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loading from "../Loading";
import { Box, Button } from "@mui/material";
import Mixpanel from "../../utils/mixpanel";

const PricingTable = () => {
  const { user, logout } = useAuth0();
  const pricingTableId = process.env.REACT_APP_PRICING_TABLE_ID;
  const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

  useEffect(() => {
    const scriptId = "stripe-pricing-table-script";
    const containerId = "stripe-pricing-container";

    const injectPricingTable = () => {
      const pricingTable = document.createElement("stripe-pricing-table");
      pricingTable.setAttribute("pricing-table-id", pricingTableId!);
      pricingTable.setAttribute("publishable-key", publishableKey!);
      pricingTable.setAttribute("customer-email", user?.email || "");

      const container = document.getElementById(containerId);
      if (container) {
        container.innerHTML = ""; // Clear any previous content
        container.appendChild(pricingTable);
      }
    };

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.src = "https://js.stripe.com/v3/pricing-table.js";
      script.id = scriptId;
      script.async = true;
      script.onload = () => {
        injectPricingTable();
      };
      document.body.appendChild(script);
    } else {
      injectPricingTable();
    }
  }, [pricingTableId, publishableKey, user?.email]);

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin + "/logout",
      },
    });
    sessionStorage.clear();
    localStorage.clear();
    Mixpanel.reset();
  };

  return (
    <Box sx={styles.logoutMainContainer}>
      <Box sx={styles.logoutContainer}>
        <Button onClick={handleLogout} sx={styles.logoutButton}>
          Logout
        </Button>
      </Box>

      <h1 style={styles.selectOptionHeading}>Select a Subscription Option</h1>

      <div id="stripe-pricing-container" style={{ marginBottom: 50 }}></div>
    </Box>
  );
};

export default withAuthenticationRequired(PricingTable, {
  onRedirecting: () => <Loading />,
});
